import { PriorityBadge } from '@/components/ui';
import type { CellRendererProps } from './index';

export function PriorityCell({ value }: CellRendererProps) {
  if (value == null || value === '') return null;
  return <PriorityBadge priority={String(value)} />;
}
